"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview7_exports = {};
__export(GeodesPreview7_exports, {
  default: () => GeodesPreview7_default
});
module.exports = __toCommonJS(GeodesPreview7_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.6758 1.91016C10.5065 1.91016 10.3633 1.96875 10.2461 2.08594C10.1419 2.20312 10.0898 2.33984 10.0898 2.49609V4.58594L8.11719 5.71875L8.74219 6.34375L10.5 5.30859L14.25 7.49609V11.8516L15.0898 12.6914V12.3398H17.5898V15.1914L18.4102 16.0117V12.0859C18.4102 11.9167 18.3516 11.7799 18.2344 11.6758C18.1302 11.5586 17.9935 11.5 17.8242 11.5H15.0898V7.92578L16.125 8.53125C16.2292 8.58333 16.3333 8.59635 16.4375 8.57031C16.5547 8.54427 16.6393 8.47917 16.6914 8.375C16.7565 8.27083 16.7695 8.16667 16.7305 8.0625C16.7044 7.94531 16.6393 7.86068 16.5352 7.80859L10.9102 4.58594V3.58984H12.4141C12.5833 3.58984 12.7201 3.53125 12.8242 3.41406C12.9414 3.29688 13 3.16016 13 3.00391V2.49609C13 2.33984 12.9414 2.20312 12.8242 2.08594C12.7201 1.96875 12.5833 1.91016 12.4141 1.91016H10.6758ZM6.67188 6.53906L4.46484 7.80859C4.36068 7.86068 4.28906 7.94531 4.25 8.0625C4.22396 8.16667 4.24349 8.27083 4.30859 8.375C4.36068 8.47917 4.4388 8.54427 4.54297 8.57031C4.66016 8.59635 4.77083 8.58333 4.875 8.53125L5.91016 7.92578V11.5H3.17578C3.00651 11.5 2.86328 11.5586 2.74609 11.6758C2.64193 11.7799 2.58984 11.9167 2.58984 12.0859V16.7539C2.58984 16.9102 2.64193 17.0469 2.74609 17.1641C2.86328 17.2812 3.00651 17.3398 3.17578 17.3398H17.4727L17.707 17.5547C17.7852 17.6458 17.8828 17.6914 18 17.6914C18.1172 17.6914 18.2148 17.6458 18.293 17.5547C18.3711 17.4766 18.4102 17.3854 18.4102 17.2812C18.4102 17.1641 18.3711 17.0599 18.293 16.9688L5.38281 4.05859C5.30469 3.98047 5.20703 3.94141 5.08984 3.94141C4.97266 3.94141 4.875 3.98047 4.79688 4.05859C4.70573 4.13672 4.66016 4.23438 4.66016 4.35156C4.66016 4.46875 4.70573 4.56641 4.79688 4.64453L6.67188 6.53906ZM16.6328 16.5H15.0898V14.9375L16.6328 16.5ZM14.25 14.1172V16.5H12.5898V13.7461C12.5898 13.5898 12.5312 13.4531 12.4141 13.3359C12.2969 13.2188 12.1602 13.1602 12.0039 13.1602H8.99609C8.83984 13.1602 8.70312 13.2188 8.58594 13.3359C8.46875 13.4531 8.41016 13.5898 8.41016 13.7461V16.5H6.75V7.49609L7.31641 7.16406L8.625 8.49219C8.5599 8.63542 8.50781 8.78516 8.46875 8.94141C8.42969 9.09766 8.41016 9.25391 8.41016 9.41016C8.41016 9.99609 8.61198 10.4909 9.01562 10.8945C9.43229 11.2982 9.92708 11.5 10.5 11.5C10.6693 11.5 10.832 11.4805 10.9883 11.4414C11.1445 11.4023 11.2878 11.3503 11.418 11.2852L14.25 14.1172ZM10.7734 10.6406C10.7344 10.6536 10.6888 10.6602 10.6367 10.6602C10.5977 10.6602 10.5521 10.6602 10.5 10.6602C10.1484 10.6602 9.84896 10.543 9.60156 10.3086C9.36719 10.0612 9.25 9.76172 9.25 9.41016C9.25 9.37109 9.25 9.33203 9.25 9.29297C9.26302 9.24089 9.27604 9.1888 9.28906 9.13672L10.7734 10.6406ZM9.25 14H11.75V16.5H9.25V14ZM5.91016 12.3398V16.5H3.41016V12.3398H5.91016ZM10.5586 8.16016C10.8841 8.1862 11.1576 8.3099 11.3789 8.53125C11.6133 8.7526 11.737 9.02604 11.75 9.35156L12.4727 10.0742C12.5117 9.97005 12.5378 9.86589 12.5508 9.76172C12.5768 9.64453 12.5898 9.52734 12.5898 9.41016C12.5898 8.83724 12.3815 8.34896 11.9648 7.94531C11.5612 7.54167 11.0729 7.33984 10.5 7.33984C10.3828 7.33984 10.2656 7.34635 10.1484 7.35938C10.0443 7.3724 9.9401 7.39844 9.83594 7.4375L10.5586 8.16016Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview7 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview7_default = SvgGeodesPreview7;
